<template>
  <div class="lp" v-if="entry">
    <MatrixBlockLandingPageContent
      :matrix-blocks="entry.landingPageContent2023"
      :entry-type="'landingPage2023'"
      v-if="entry.landingPageContent2023?.length"
    />
    <MatrixBlockLandingPageContent
      :matrix-blocks="entry.landingPageContent"
      entry-type="landingPage"
      v-if="entry.landingPageContent?.length"
    />
  </div>
</template>

<script>
import { defineComponent, reactive, toRefs, useContext, useFetch, useMeta, useStore } from '@nuxtjs/composition-api';
import { homeGql } from 'GQL/homeGql.js';
import { log } from 'JS/global.js';
import { gqlToObject } from 'JS/seomatic.js';
import MatrixBlockLandingPageContent from 'Components/matrix_blocks/MatrixBlockLandingPageContent.vue';

export default defineComponent({
  name: 'SiteHome',
  head: {},
  components: {
    MatrixBlockLandingPageContent,
  },
  setup() {
    const { app, $craft, payload, $preview } = useContext();
    const store = useStore();
    const state = reactive({
      entry: null,
      seomatic: null,
    });

    useFetch(async () => {
      let data;
      if (!$preview && payload?.entry) {
        data = payload;
      } else {
        const request = await $craft({
          apiLog: 'SiteHome',
          query: homeGql,
          variables: {
            site: store.state.global.localeSites[app.i18n.locale].siteHandle,
          },
        });

        if (request?.data) {
          data = request.data;
        }
      }

      if (data?.entry) {
        state.entry = data.entry;

        if (data.entry.seomatic) {
          state.seomatic = data.entry.seomatic;
        }
        if (state.entry?.navigationTheme) {
          store.commit('global/updateGlobalDarkTheme', true);
        } else {
          store.commit('global/updateGlobalDarkTheme', false);
        }
      }
    });

    useMeta(() => {
      return state.seomatic ? { ...gqlToObject(state.seomatic) } : {};
    });

    return { ...toRefs(state) };
  },
  mounted() {
    log('SiteHome loaded');
  },
});
</script>

<style lang="scss">
.lp {
  position: relative;
}
</style>
